const ErrorFill: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="Action/error-fill">
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5229 2 22 6.47715 22 12C22 17.5229 17.5229 22 12 22ZM11.2063 7.23809C11.2063 6.79977 11.5617 6.44444 12 6.44444C12.4383 6.44444 12.7936 6.79977 12.7936 7.23809V12.7936C12.7936 13.232 12.4383 13.5873 12 13.5873C11.5617 13.5873 11.2063 13.232 11.2063 12.7936V7.23809ZM13.1905 16.3651C13.1905 15.7076 12.6575 15.1746 12 15.1746C11.3425 15.1746 10.8095 15.7076 10.8095 16.3651C10.8095 17.0226 11.3425 17.5556 12 17.5556C12.6575 17.5556 13.1905 17.0226 13.1905 16.3651Z"
        fill="#C8102E"
      />
    </g>
  </svg>
);

export default ErrorFill;
